export class ExchangeRate {
    constructor() {
        this.rate = null;
        this.inversion = null;
        this.base = null;
        this.quoted = null;
    }

    static create(data) {
        return Object.assign(new ExchangeRate(), data);
    }

    getCounterCurrency(currency) {
        return currency === this.base ? this.quoted : this.base;
    }
}
